const actions = {
  SET_APP_CONFIG: 'SET_APP_CONFIG',
  REFRESH_FEATURE_FLAGS: 'REFRESH_FEATURE_FLAGS'
};

export const setAppConfig = data => ({
  type: actions.SET_APP_CONFIG,
  payload: data
});

export const refreshFeatureFlags = () => ({
  type: actions.REFRESH_FEATURE_FLAGS
});

export default actions;
